export const CURRENT_CONFIG = {

  // license
  appId: '199316', // You need to go to the development website to apply.
  appKey: '683b03a36119886d4068b6baade6636', // You need to go to the development website to apply.
  appLicense: 'WmR540kfUQcBP4Oxat9zYNzAjyzaSW1VCa/WcNVmh7PVz33sKC2hgW8MUS6LlfKElo9ntHhGbu1uGF3QrdvPZ643e71qnfUTTn/hScX9758MDFEn7v48eZPhBADixNiYJzoc7ueMNj1wHi4opPu8M3s1jME5DM/wPi0f1eFqbRY=', // You need to go to the development website to apply.

  // http
  baseURL: 'https://drone.agl-survey.fr/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'wss://drone.agl-survey.fr/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
